export default [
	{ label: 'Username', name: 'username', type: 'text' },
	{ label: 'Passwort', name: 'password', type: 'password' }
]



// WEBPACK FOOTER //
// ./src/components/login/formFields.js